import useMenuItemDashboardDataObject from './useMenuItemDashboardDataObject.jsx'
import useMenuItemDashboardTable from './useMenuItemDashboardTable.jsx'
import useMenuItemManifestDataObject from './useMenuItemManifestDataObject.jsx'
import useMenuItemManifestDataObjectElement from './useMenuItemManifestDataObjectElement.jsx'
import useMenuItemManifestForeignKey from './useMenuItemManifestForeignKey.jsx'
import useMenuItemManifestMissingDataObjectElement from './useMenuItemManifestMissingDataObjectElement.jsx'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonDataRelation(props) {
    const items = [
        useMenuItemManifestForeignKey(),
        useMenuItemManifestDataObject(),
        useMenuItemManifestDataObjectElement(),
        useMenuItemManifestMissingDataObjectElement(),
        useMenuItemDashboardTable(),
        useMenuItemDashboardDataObject(),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            数据关系分析
        </MenuButton>
    )
}
